export default __webpack_public_path__ + "static/media/Yosemite.55115f82.jpg";